import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconLinkedinBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconLinkedinBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0c67837545505c7ba4d3efb971a189ecd090936a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fbcd8e083b6296617bccb99b3b18c556a8a2bc68', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '5b75cbc62100c4d99935cff5dfdbf79c330c4c78', d: "M7.113 5.563c0 .863-.694 1.562-1.55 1.562s-1.55-.7-1.55-1.562S4.706 4 5.563 4c.856 0 1.55.7 1.55 1.563m.012 2.812H4v10h3.125zm4.989 0H9.009v10h3.105v-5.25c0-2.918 3.768-3.157 3.768 0v5.25H19v-6.332c0-4.925-5.576-4.745-6.886-2.321z", fill: "#0B66C2" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-linkedin-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-linkedin-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-linkedin-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconLinkedinBranded$1);
            }
            break;
    } });
}

const CosmosIconLinkedinBranded = CosmosIconLinkedinBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconLinkedinBranded, defineCustomElement };
